import { startsWith } from 'lodash'
import i18n from '@/libs/i18n'
import * as Sentry from '@sentry/vue'
import router from '@/router/router'
import { useToaster } from '@/composables/useToaster'
import $bvModal from '@/composables/useBVModal'

// MFC2-1626 — les messages sous ce prefixe sont des AVERTISSEMENTS METIER qui doivent etre lus, pas
// des erreurs techniques fugaces. Diana : "peux-tu mettre un pop up pour cette alerte qui s'affiche
// si on souhaite supprimer HANDLING et qui est fermable par OK ? Ainsi l'user a le temps de lire
// l'alerte (elle n'est plus intermittente)".
// Ils sont donc presentes en modale fermable par OK, au lieu du toast qui disparait seul.
const BUSINESS_WARNING_PREFIX = 'leon.warning.'

let _title = ''
let _variant = 'danger'
let _text = ''

const _setNotifError4xx = error => {
  if (
    startsWith(error?.response?.data?.message, 'errors') && i18n.global.te(error?.response?.data?.message)
  ) {
    _title = i18n.global.t(error.response.data.message)
    const { errors } = error.response.data
    if (typeof errors === 'object' && !Array.isArray(errors)) {
      // Display only first sub error to prevent a big notif
      const errorKey = Object.entries(errors)[0][0]
      const errorText = i18n.global.te(Object.entries(errors)[0][1])
        ? i18n.global.t(Object.entries(errors)[0][1])
        : Object.entries(errors)[0][1]
      _text = `${errorKey}: ${errorText}`
    }
  } else {
    _title = `${i18n.global.t('request.status.error.client')} : ${error.response.status}`
    const errorsObj = error?.response?.data?.errors

    _text = error?.response?.data?.message || ''
    if (errorsObj && Object.keys(errorsObj).length > 0) {
      [_text] = Object.values(errorsObj)
    }
  }
}

const errorHandler = error => {
  let withErrorToast = true

  switch (true) {
    case error.code === 'ECONNABORTED':
      _title = i18n.global.t('request.econnaborted.status')
      _text = i18n.global.t('request.econnaborted.statusText')
      break
    case error.code === 'ERR_CONNECTION_RESET':
      _title = i18n.global.t('request.err_connection_reset.status')
      _text = i18n.global.t('request.err_connection_reset.statusText')
      break
    case error.code === 'ERR_EMPTY_RESPONSE' || !error.response:
      _title = i18n.global.t('request.err_empty_response.status')
      _text = i18n.global.t('request.err_empty_response.statusText')
      break
    case error.response.status < 400:
      _title = `${i18n.global.t('request.status.redirect')} : ${error.response.status}`
      _variant = 'info'
      _text = error.response.data.message
      break
    case error.response.status === 403:
      /* _setNotifError4xx(error)
      _variant = 'warning' */
      withErrorToast = false
      router.push({ name: 'not-authorized', query: { redirect: router.currentRoute.path } })
      break
    case error.response.status === 409:
      withErrorToast = false
      localStorage.setItem('showConflictNotification', 'true')
      window.location.reload()
      break
    case error.response.status === 400 || (error.response.status > 401 && error.response.status < 500):
      _setNotifError4xx(error)
      _variant = 'warning'
      break
    case error.response.status < 600:
      _title = `${i18n.global.t('request.status.error.server')} : ${error.response.status}`
      _variant = 'danger'
      _text = error.response.data.message
      break
    default:
      break
  }

  if (error.config.withErrorToast !== undefined) {
    withErrorToast = error.config.withErrorToast
  }

  // MFC2-1626 — avertissement metier : modale a acquitter plutot que toast.
  // On teste messageCode et NON message : l'API traduit le message avant de le renvoyer
  // (ExceptionService::createErrorWithMessage appelle translator->trans), le champ message contient
  // donc une phrase et non la cle. messageCode, lui, porte la cle brute.
  // Retour Diana du 25/08 : "la traduction de la 400 remonte en Front maintenant, mais je n'ai pas
  // le POP UP" — c'etait exactement ce decalage.
  // Le texte affiche vient du catalogue de l'OPERATEUR : soit deja traduit par l'API dans le champ
  // message, soit resolu par i18n, qui fusionne au demarrage les traductions renvoyees par l'API
  // (initI18n -> mergeLocaleMessage). Aucune traduction n'est codee en dur cote Front pour ces
  // avertissements : elle entrerait en concurrence avec celle de l'operateur (retour Diana du 26/08,
  // "la trad Operateur MFC ne remonte pas, c'est toujours celle par defaut dans le code").
  const apiMessageCode = error?.response?.data?.messageCode
  const apiMessage = error?.response?.data?.message
  if (withErrorToast && startsWith(apiMessageCode, BUSINESS_WARNING_PREFIX)) {
    withErrorToast = false
    const texte = apiMessage && apiMessage !== apiMessageCode
      ? apiMessage
      : i18n.global.t(apiMessageCode)

    $bvModal.msgBoxConfirm(texte, {
      title: i18n.global.t('common.warning'),
      okOnly: true,
      okTitle: 'OK',
      okVariant: 'warning',
      centered: true,
    })
  }

  if (withErrorToast) {
    const { toaster } = useToaster()
    toaster(_title, _variant, 'AlertTriangleIcon', _text)
  }

  Sentry.captureException(error.response.data.message)

  return error
}

export default errorHandler
